<template>
  <div v-if="showView">
    <header class="header fixed-top">
      <nav class="navbar navbar-light bg-light">
        <div class="container navbarCont" style="padding: 0">
          <a class="navbar-brand">
            <img src="../assets/logo3.png" class="logo" />
          </a>
          <form class="form-inline searchbox">
            <input
              type="text"
              class="navInput"
              placeholder="请输入关键字"
              placeholder-class="ipt"
            />
            <button class="navbtn" type="submit">
              <img src="../assets/search.png" class="searchico" />
              搜索
            </button>
          </form>
        </div>
      </nav>
      <nav
        class="navbar navbar-expand-lg navbar-light"
        :class="[scrollTop > 100 ? 'shadow' : '']"
        :style="{ background: backgroundColor }"
      >
        <div
          class="container navBox"
          style="display: flex; justify-content: flex-end"
        >
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="collapseNav"
          >
            <span class="navbar-toggler-icon">
              <img v-if="isCollapse" :src="bgimg1" />
              <img v-else :src="bgimg2" />
            </span>
          </button>

          <div
            class="collapse navbar-collapse"
            id="navbarsExampleDefault"
            style="justify-content: center"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/"
                  >首页</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/about"
                  >关于我们</router-link
                >
              </li>
              <li
                class="nav-item"
                :class="[scrollTop > 100 ? 'active2' : 'active']"
              >
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/product"
                  >产品中心</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/support"
                  >技术支持</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/news"
                  >新闻动态</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/contact"
                  >联系我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/hire"
                  >人才招聘</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <div class="spacebox"></div>
    <main>
      <!-- 顶部图 -->
      <div class="pictureBox" v-if="picture">
        <img :src="picture.P_IMG" />
      </div>

      <div class="requestCont container">
        <!-- 表格 -->
        <div class="tableBox">
          <table border="1">
            <thead>
              <tr class="tableHeader">
                <th></th>
                <th colspan="2">产品</th>
                <th>数量</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in productArray" :key="index">
                <td @click="deleteItem(index)">
                  <span class="remove">x</span>
                </td>
                <td @click="openDetails(item.DB_PRODUCT_ID)">
                  <a
                    :href="'/productDetail?id=' + item.DB_PRODUCT_ID"
                    target="_blank"
                    ><img :src="item.P_IMG"
                  /></a>
                </td>
                <td
                  @click="openDetails(item.DB_PRODUCT_ID)"
                  style="text-align: left"
                >
                  <a
                    :href="'/productDetail?id=' + item.DB_PRODUCT_ID"
                    target="_blank"
                    >{{ item.P_NAME }}</a
                  >
                </td>
                <td>
                  <input
                    type="number"
                    :style="{ 'border': curNum == index ? '3px solid #000' : '1px solid #000' }"
                    min="1"
                    v-model="item.num"
                    @focus="getFocus(index)"
                    @input="getInputValue(index, item.num)"
                    @blur="blurValue(index, item.num)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 索取更多信息 -->
        <div class="requestInfo">
          <div class="title">索取更多信息</div>
          <div class="noteWords">
            请填写下面的表格，我们会尽快回复您。感谢您对采航贸易的关注。
          </div>
          <form autocomplete="off" @submit.prevent="submit">
            <div class="form-group flexStart formGroup1">
              <label class="label">姓名:<i style="color: #ff0000">*</i></label>
              <input
                type="text"
                class="form-control formInput"
                v-model="name"
              />
            </div>
            <div class="form-group flexStart formGroup1">
              <label class="label">公司:<i style="color: #ff0000">*</i></label>
              <input
                type="text"
                class="form-control formInput"
                v-model="firm"
              />
            </div>
            <div class="form-group flexStart formGroup1">
              <label class="label"
                >国家/区域:<i style="color: #ff0000">*</i></label
              >
              <div class="inputBox" @click="handleOptsbox(1)">
                <input
                  type="text"
                  class="select"
                  placeholder="选择..."
                  readonly="readonly"
                  value="country"
                  v-model="country"
                />
                <img src="../assets/xz.png" />
              </div>
              <ul class="options" v-if="isShow1 && countryList.length != 0">
                <li
                  class="opt-item"
                  v-for="(item, index) in countryList"
                  :key="index"
                  :class="[item.isSelected ? 'selected' : '']"
                  @click="choose('国家', index)"
                >
                  <span>{{ item.T_NAME }}</span>
                </li>
              </ul>
            </div>
            <div class="form-group flexStart formGroup1">
              <label class="label">电话:<i style="color: #ff0000">*</i></label>
              <input
                type="tel"
                class="form-control formInput"
                v-model="telephone"
              />
            </div>
            <div class="form-group flexStart formGroup1">
              <label class="label">邮箱:<i style="color: #ff0000">*</i></label>
              <input
                type="email"
                class="form-control formInput"
                v-model="email"
              />
            </div>
            <div class="form-group flexStart formGroup1">
              <label class="label">行业:<i style="color: #ff0000">*</i></label>
              <div class="inputBox" @click="handleOptsbox(2)">
                <input
                  type="text"
                  class="select"
                  placeholder="选择..."
                  readonly="readonly"
                  value="field"
                  v-model="field"
                />
                <img src="../assets/xz.png" />
              </div>
              <ul class="options" v-if="isShow2 && fieldList.length != 0">
                <li
                  class="opt-item"
                  v-for="(item, index) in fieldList"
                  :key="index"
                  :class="[item.isSelected ? 'selected' : '']"
                  @click="choose('行业', index)"
                >
                  <span>{{ item.T_NAME }}</span>
                </li>
              </ul>
            </div>
            <div class="form-group flexStart formGroup1">
              <label class="label"
                >你需要那些帮助:<i style="color: #ff0000">*</i></label
              >
              <textarea
                class="form-control formText"
                rows="10"
                v-model="help"
              ></textarea>
            </div>
            <!-- <div class="form-row" style="margin: 0">
            <div class="form-group col-md-6 flexStart formGroup1">
              <label class="label">你感兴趣的产品:<i style="color: #ff0000">*</i></label>
              <input type="text" class="form-control formInput specialInput" v-model="product" disabled />
            </div>
            <div class="form-group col-md-6 flexStart formGroup1">
              <label class="label">数量:<i style="color: #ff0000">*</i></label>
              <input type="number" class="form-control formInput" v-model="count" oninput="if(value<1)value=1" />
            </div>
          </div> -->
            <div class="agreement">
              <div class="choose" @click="readAgreement()">
                <img v-if="isReading" src="../assets/xzxz.png" />
                <img v-else src="../assets/wxz.png" />
              </div>
              <div class="content">
                我已阅读并同意威立雅的<span @click="toSetting()"
                  >《隐私政策》</span
                >,我愿意订阅有关产品、服务和活动的电子邮件更新.
              </div>
            </div>
            <button type="submit" class="tjBtn">
              <img src="../assets/tj.png" /><span>提交</span>
            </button>
          </form>
        </div>
      </div>

      <!-- 提醒弹窗 -->
      <div class="modal-bg" v-if="isShow4">
        <div class="modal-container">
          <div class="modal-top">
            <p class="modal-title">信息</p>
            <img
              src="../assets/cancel.png"
              class="close"
              @click="hideModal()"
            />
          </div>

          <div class="modal-main">{{ message }}</div>
          <div class="modal-bottom">
            <p class="confirmBtn" @click="hideModal">确定</p>
          </div>
        </div>
      </div>
    </main>
    <bottomFooter />
  </div>
</template>

<style>
/* 去掉默认样式 */
p {
  margin-bottom: 0;
}

.requestCont {
  display: flex;
  justify-content: space-between;
  padding: 0 !important;
}

/* 表格 */
.tableBox {
  width: 49%;
  margin-top: 3rem;
}

.tableBox table {
  width: 100%;
}

.tableHeader th {
  line-height: 1.75rem;
  font-size: 1.75rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  padding: 1.875rem 0.9375rem;
}

table td {
  padding: 0.5625rem 0.75rem;
  vertical-align: middle;
  line-height: 1.5em;
}

tbody tr:nth-of-type(2n + 1) {
  background-color: rgba(0, 0, 0, 0.05);
}

tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.07);
}

.remove {
  display: block;
  height: 1rem;
  width: 1rem;
  line-height: 1.5rem;
  font-size: 1.5rem;
  font-family: Microsoft YaHei;
  text-align: center;
  color: red !important;
  text-decoration: none;
  font-weight: 700;
  border-radius: 100%;
  border: 0;
}

table img {
  width: 8.875rem;
  height: 8.875rem;
}

table a {
  /* width: 13rem; */
  line-height: 1rem;
  font-size: 1em;
  font-family: Microsoft YaHei;
  text-align: left;
  color: #c36;
  text-decoration: underline;
}

table a:hover {
  color: #333;
}

table input {
  width: 4.5em;
  text-align: center;
  border: 1px solid #000;
}

/* 索取更多信息 */
.requestInfo {
  width: 46%;
  text-align: left;
  margin-top: 5.6875rem;
}

.requestInfo .title {
  width: 100%;
  line-height: 2.5rem;
  font-size: 2.3rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  padding-left: 0.3125rem;
  box-sizing: border-box;
}

.requestInfo .noteWords {
  width: 100%;
  line-height: 1.7rem;
  font-size: 1.4rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  color: #333333;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

/* 表单 */
.form-row {
  margin-left: 0;
}

.form-group > .label {
  line-height: 1.2rem;
  font-size: 1.2rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin-bottom: 0.625rem !important;
}

.form-group > .formInput {
  width: 100%;
  height: 3rem !important;
  line-height: 1rem !important;
  font-size: 1rem !important;
  font-family: Microsoft YaHei;
  font-weight: 500 !important;
  color: #333333 !important;
  background: #f2f2f2 !important;
  border-color: #f2f2f2 !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  outline: none;
}

.form-group > .formInput:focus {
  background: #f2f2f2 !important;
  border-color: #f2f2f2 !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  outline: none;
}

.formGroup1 {
  margin-bottom: 1.25rem !important;
}

.form-group > .formText {
  line-height: 1rem !important;
  font-size: 1rem !important;
  font-family: Microsoft YaHei;
  font-weight: 500 !important;
  color: #333333 !important;
  background: #f2f2f2 !important;
  border-color: #f2f2f2 !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  outline: none;
  resize: none;
}

.flexStart {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.form-group .inputBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3rem !important;
  background: #f2f2f2 !important;
  border: none;
  outline: none;
  padding: 0.5rem .75rem;
  box-sizing: border-box;
}

.form-group .inputBox > img {
  width: 1.2rem;
  height: 0.7rem;
}

.form-group .inputBox .select {
  width: calc(100% - 3rem);
  height: 3rem;
  line-height: 1rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #333333;
}

.ipt {
  color: #a4a3a3;
}

.options {
  width: 100%;
  height: 18rem;
  background: #f2f2f2;
  border: 1px solid #333333;
  box-shadow: 0px 1px 0.8125rem 0px rgba(0, 0, 0, 0.2);
  overflow: scroll;
}

ul,
li {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.opt-item {
  display: flex;
  align-items: center;
  width: 100%;
  height: 2rem;
  line-height: 0.9rem;
  font-size: 0.9rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  background: #f2f2f2;
  padding-left: 0.625rem;
  box-sizing: border-box;
}

.opt-item span {
  height: 0.7rem;
}

.selected {
  line-height: 0.7rem;
  font-weight: bold;
  color: #ffffff;
  background: #020e62;
  box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.2);
}

.selected span {
  height: 0.7rem;
}

.agreement {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 1.75rem;
}

.agreement .choose {
  width: 1.4rem;
  height: 1.3rem;
  margin-right: 1rem;
  margin-top: 0.25rem;
  margin-left: 0.5rem;
}

.agreement .choose img {
  width: 100%;
  height: 100%;
}

.agreement .content {
  width: calc(100% - 3rem);
  line-height: 1.4rem;
  font-size: 1.2rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  text-align: left;
  color: #333333;
  cursor: pointer;
}

.agreement .content span {
  color: #020e62;
}

.tjBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  line-height: 1.3125rem;
  font-size: 1.375rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  background: #020e62;
  opacity: 0.73;
  margin-top: 4rem;
  margin-bottom: 10rem;
  padding: 1.625rem;
  box-sizing: border-box;
}

.tjBtn img {
  width: 1.4375rem;
  height: 0.6875rem;
  margin-right: 0.5625rem;
}

.tjBtn span {
  height: 1.3125rem;
}

.modal-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.modal-container {
  width: 17.5rem;
  border-radius: 0.3125rem;
  background: #fff;
}

.modal-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3.125rem;
  line-height: 1rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid #f2f2f2;
  padding: 0 0.625rem;
  box-sizing: border-box;
}

.modal-top .close {
  width: 0.9375rem;
  height: 0.9375rem;
}

.modal-main {
  text-align: left;
  padding: 1.25rem 2.5rem;
}

.modal-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding-right: 1.25rem;
  margin-bottom: 0.9375rem;
  box-sizing: border-box;
}

.confirmBtn {
  line-height: 0.875rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #fff;
  background: #020e62;
  padding: 0.625rem 1.25rem;
}

@media screen and (max-width: 992px) {
  .requestCont {
    width: 90% !important;
  }

  .tableHeader th {
    line-height: 1.5rem;
    font-size: 1.5rem;
    padding: 1.5rem 0.7rem;
  }

  table img {
    width: 0;
    height: 0;
  }

  .requestInfo {
    margin-top: 4.5rem;
  }

  .requestInfo .title {
    line-height: 2.1rem;
    font-size: 1.9rem;
  }

  .requestInfo .noteWords {
    line-height: 1.5rem;
    font-size: 1.2rem;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .agreement .choose {
    width: 1.3rem;
    height: 1.2rem;
    margin-right: 0.7rem;
    margin-top: 0.25rem;
    margin-left: 0.3rem;
  }

  .agreement .content {
    width: calc(100% - 2.4rem);
    line-height: 1.2rem;
    font-size: 1rem;
  }

  .tjBtn {
    line-height: 1.25rem;
    font-size: 1.25rem;
    margin-top: 3rem;
    margin-bottom: 8rem;
    padding: 1.5rem;
  }
}

@media screen and (max-width: 770px) {
  .requestCont {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 0 !important;
  }

  .tableBox {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  table {
    border: none;
  }

  table thead {
    display: none;
  }

  table img {
    width: 8.5rem;
    height: 8.5rem;
  }

  table td {
    border: none;
  }

  .requestInfo {
    width: 100%;
    margin-top: 4.5rem;
  }
}

@media screen and (max-width: 600px) {
  .requestInfo {
    margin-top: 3rem;
  }

  .requestInfo .title {
    line-height: 1.9rem;
    font-size: 1.7rem;
    padding-left: 0.3125rem;
  }

  .requestInfo .noteWords {
    line-height: 1.3rem;
    font-size: 1.1rem;
    margin-top: 1.3rem;
    margin-bottom: 1.3rem;
  }

  .formGroup1 {
    margin-bottom: 1.1rem !important;
  }

  .tjBtn {
    line-height: 1.1rem;
    font-size: 1.1rem;
    margin-top: 2.5rem;
    margin-bottom: 6rem;
    padding: 1.3rem;
  }
}

@media (max-width: 500px) {
  .requestCont {
    width: 96% !important;
    margin: 0 auto;
  }

  .tableBox {
    width: 100%;
    margin-top: 1.25rem;
  }

  .remove {
    line-height: 1rem;
    font-size: 1rem;
  }

  table img {
    width: 6rem;
    height: 6rem;
  }

  table td {
    padding: 0.5rem;
  }

  table a {
    line-height: 0.8rem;
    font-size: 0.8em;
  }

  table input {
    width: 3rem;
  }

  .requestInfo {
    margin-top: 2.5rem;
  }
  .agreement .choose {
    width: 1.3rem;
    height: 1.2rem;
    margin-right: 0.5rem;
    margin-top: 0.25rem;
    margin-left: 0.3rem;
  }

  .agreement .content {
    width: calc(100% - 2.1rem);
    line-height: 1.1rem;
    font-size: 0.9rem;
  }

  .tjBtn {
    line-height: 1.1rem;
    font-size: 1.1rem;
    margin: 2rem auto 4rem;
    padding: 1.2rem;
  }
}
</style>

<script>
import bottomFooter from "@/components/bottomFooter.vue";
// import { getBackground, getTypeList, saveDemand } from "../api/interface"; // 引入接口
import { getBackground, getTypeList } from "../api/interface"; // 引入接口
import axios from "axios";
export default {
  name: "requestInfo",
  components: {
    bottomFooter,
  },
  data() {
    return {
      backgroundColor: "",
      fontColor: "",
      scrollTop: 0,
      picture: null,
      showView: false,
      countryList: [],
      fieldList: [],
      isShow1: false,
      isShow2: false,
      name: "",
      firm: "",
      country: "选择...",
      telephone: "",
      email: "",
      field: "选择...",
      help: "",
      // product: "",
      // count: 1,
      isReading: false,
      message: "",
      isShow4: false, //是否展示消息弹窗
      isCollapse: true, //是否折叠导航条
      bgimg1: require("../assets/collapse.png"),
      bgimg2: require("../assets/close1.png"),
      productArray: [], //localStorage中的产品数组
      curNum: -1, //当前点击的产品列表里的input的下标
    };
  },

  created() {
    // console.log(this.$route.query.prodname);
    // let prodname = this.$route.query.prodname;
    // this.$set(this, "product", prodname);
    this.getImg();
    this.getTypeList();
  },

  mounted() {
    // 获取localStorage中的产品数组
    let productArray = JSON.parse(localStorage.getItem("productArray") || "[]");
    this.$set(this, "productArray", productArray);
    console.log("localStorage中的产品数组:", this.productArray);
    //首先，在mounted钩子window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    //然后在方法中，添加这个handleScroll方法来获取滚动的位置
    handleScroll() {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      let scrollTop = document.documentElement.scrollTop;
      console.log("scrollTop", scrollTop);
      //设置页面滚动时目录导航栏的背景颜色
      if (scrollTop > 100) {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "#fff");
        this.$set(this, "fontColor", "#000000!important");
      } else {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "rgba(0, 0, 0, 0.1)");
        this.$set(this, "fontColor", "#ffffff");
      }
    },

    // 折叠导航栏
    collapseNav() {
      const that = this;
      that.$set(that, "isCollapse", !that.isCollapse);
    },

    // 获取图片数据
    async getImg() {
      const that = this;
      await getBackground({ P_INFO: "product-center" }).then((res) => {
        console.log(res);
        if (res.state == "success") {
          that.$set(that, "picture", res.picture);
          if (that.picture != null) {
            that.$set(that, "showView", true);
          }
        }
      });
    },

    // 获取国家、产业、行业
    async getTypeList() {
      const that = this;
      await getTypeList().then((res) => {
        console.log(res);
        if (res.state == "success") {
          let nation = res.nation,
            profession = res.profession;
          nation.forEach((v) => {
            v.isSelected = false;
          });
          profession.forEach((v) => {
            v.isSelected = false;
          });
          nation.unshift({
            T_NAME: "选择...",
            DB_TYPE_ID: "",
            isSelected: true,
          });
          profession.unshift({
            T_NAME: "选择...",
            DB_TYPE_ID: "",
            isSelected: true,
          });
          console.log(nation, profession);
          that.$set(that, "countryList", nation);
          that.$set(that, "fieldList", profession);
        }
      });
    },

    // 选择框出现/隐藏
    handleOptsbox(idx) {
      if (idx === 1) {
        this.$set(this, "isShow1", !this.isShow1);
      } else if (idx === 2) {
        this.$set(this, "isShow2", !this.isShow2);
      }
    },

    //选择了哪一项
    choose(name, idx) {
      if (name == "国家") {
        let countryList = this.countryList;
        for (let i = 0; i < countryList.length; i++) {
          if (idx === i) {
            countryList[i].isSelected = true;
          } else {
            countryList[i].isSelected = false;
          }
        }
        this.$set(this, "country", countryList[idx].T_NAME);
        this.$set(this, "countryList", countryList);
        this.$set(this, "isShow1", false);
      } else if (name == "行业") {
        let fieldList = this.fieldList;
        for (let i = 0; i < fieldList.length; i++) {
          if (idx === i) {
            fieldList[i].isSelected = true;
          } else {
            fieldList[i].isSelected = false;
          }
        }
        this.$set(this, "field", fieldList[idx].T_NAME);
        this.$set(this, "fieldList", fieldList);
        this.$set(this, "isShow2", false);
      }
    },

    // 删除某一项
    deleteItem(idx) {
      console.log(`删除第${idx + 1}个产品`);
      let productArray = this.productArray;
      productArray.splice(idx, 1);
      this.$set(this, "productArray", productArray);
      localStorage.setItem("productArray", JSON.stringify(productArray));
    },

    // 返回详情页
    openDetails(id) {
      console.log("点击的产品id是：" + id);
      this.$router.replace({ path: "/productDetail", query: { id: id } });
    },

    // 获取焦点
    getFocus(idx) {
      this.$set(this, "curNum", idx);
    },

    // 输入数量
    getInputValue(idx, value) {
      console.log(`第${idx + 1}个输入框的值: `, value);
      let productArray = this.productArray;
      productArray[idx].num = parseInt(value);
      this.$set(this, "productArray", productArray);
    },

    // 获取产品列表中当前项输入的数量值
    blurValue(idx, value) {
      this.$set(this, "curNum", -1);
      console.log(`第${idx + 1}个输入框的值: `, value);
      let productArray = this.productArray;
      productArray[idx].num = value ? parseInt(value) : 1;
      if (productArray[idx].num === 0) {
        productArray[idx].num = 1;
      }
      this.$set(this, "productArray", productArray);
      localStorage.setItem("productArray", JSON.stringify(productArray));
    },

    //是否阅读协议
    readAgreement() {
      console.log(this.isReading);
      this.$set(this, "isReading", !this.isReading);
    },

    // 去隐私政策页面
    toSetting() {
      let settingType = "service-agreement";
      this.$router.push({
        path: "/setting",
        query: { settingType: settingType },
      });
    },

    // 是否展示消息弹窗
    hideModal() {
      this.$set(this, "isShow4", false);
    },

    // 提交表单
    submit(e) {
      e.preventDefault(); // 阻止默认提交行为
      console.log(
        this.name,
        this.firm,
        this.country,
        this.telephone,
        this.email,
        this.field,
        this.help,
        this.productArray,
        this.isReading
      );
      var regMobile = /^1[34578]\d{9}$/; //或者为/^1[3|4|5|7|8][0-9]\d{8}$/;
      var regEmail = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/; //邮箱验证
      if (
        this.name == "" ||
        this.firm == "" ||
        this.telephone == "" ||
        this.email == "" ||
        this.help == ""
      ) {
        this.$set(this, "message", "请填写完必填信息！");
        this.$set(this, "isShow4", true);
        console.log("showView", this.showView);
      } else if (!this.isReading) {
        this.$set(this, "message", "请阅读协议并确认！");
        this.$set(this, "isShow4", true);
      } else if (!regMobile.test(this.telephone)) {
        this.$set(this, "message", "手机号格式不正确！");
        this.$set(this, "isShow4", true);
      } else if (!regEmail.test(this.email)) {
        this.$set(this, "message", "邮箱格式不正确！");
        this.$set(this, "isShow4", true);
      } else if (this.country == "选择...") {
        this.$set(this, "message", "请选择国家/区域！");
        this.$set(this, "isShow4", true);
      } else if (this.field == "选择...") {
        this.$set(this, "message", "请选择专业！");
        this.$set(this, "isShow4", true);
      } else {
        let params = {
          D_NAME: this.name,
          D_FRIM: this.firm,
          D_NATION: this.country,
          D_PHONE: this.telephone,
          D_EMAIL: this.email,
          D_PROFESSION: this.field,
          D_PRODUCT: this.productArray,
          D_HELP: this.help,
        };
        console.log(params);
        let url = "http://manage.astsciencecorp.com.cn/color_flight";
        // let url = "https://xcx.hyxt-ec.com/color_flight";
        url = url + "/app/index/appSaveDemand";
        let config = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        let that = this;
        axios
          .post(url, params, config)
          .then(function (res) {
            console.log(res.data);
            if (res.data.state == "success") {
              that.$set(that, "message", "提交信息成功");
              that.$set(that, "isShow4", true);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
  },

  //由于是在整个window中添加的事件，所以要在页面离开时摧毁掉，否则会报错
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  // beforeRouteLeave(to, from, next) {
  //   //设置下一个路由的meta,让列表页面缓存,即不刷新
  //   to.meta.keepAlive = true;
  //   next();
  // },
};
</script>
